import {FC, PropsWithChildren, useContext, useEffect} from 'react';
import {Navigate, useNavigate} from 'react-router-dom';
import {useRecoilValue} from 'recoil';

import {authState} from '../../store/auth/atoms';
import {AuthContext} from '../AuthContextProvider';
import Fallback from '../../ui/fallback/Fallback';

const PrivateRoute: FC<PropsWithChildren> = ({children}) => {
  const {isLoggedIn, user} = useRecoilValue(authState);
  const {apiAccess} = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn && user) {
      user?.needToChangePasswd && navigate('/?pass', {replace: true});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  if (apiAccess?.loading && !apiAccess?.hasAccess) {
    return <Fallback />;
  }

  return isLoggedIn || !apiAccess?.hasAccess ? <>{children}</> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
